import { Box, Flex, Image, ListItem, Stack, Text, UnorderedList } from '@chakra-ui/react'
import { ContentLabel } from './Insurer'
import { DocumentsList } from '@/components/Documents/DocumentsList'
import { AppSettings } from '@/appSettings'

const baseUrl = AppSettings.baseUrl + '/docs/cp/'

const GCPContent = () => {
  return (
    <Stack m={4} gap={10}>
      <Documents />
    </Stack>
  )
}

export default GCPContent

const Documents = () => {
  return (
    <Stack>
      <Flex justifyContent='center' >
        <Text fontSize='4xl'>Dokumenty</Text>
      </Flex>

      <Stack gap={16} sx={{
        backgroundColor: 'white',
        p: 6
      }}>
        <DocumentsList items={[
          {
            url: baseUrl + 'cp_pojistne_podminky.pdf',
            name: 'Pojistné podmínky',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'cp_dokument_pojisteni_vozidel_ipid.pdf',
            name: 'Informační dokument o pojistném produktu - IPID',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'gcp_additionals_packages.pdf',
            name: 'Balíčky doplňků',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'gcp_asistencni_sesit_do35.pdf',
            name: 'Asistenční sešit pro vozidla do 3,5t',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'gcp_asistencni_sesit_nad35.pdf',
            name: 'Asistenční sešit pro vozidla nad 3,5t',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'zaznam_o_dopravni_nehode.pdf',
            name: 'Záznam o dopravní nehodě',
            documentType: 'pdf'
          }
        ]} />
      </Stack>
    </Stack >
  )
}